import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogoImage = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 150,
	height: 150,
	viewBox: "0 0 150 150",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M120.415 27.1012C117.955 27.959 115.813 29.4873 114.241 31.5303L108.226 39.2967L57.4224 105.015C54.6925 108.555 51.3596 111.534 47.6298 113.858L44.3445 121.655L62.771 131.496H69.056C80.6738 131.496 91.609 126.147 98.6241 117.055L140.508 62.674L145.54 56.1396C147.206 53.9875 148.142 51.3675 148.238 48.6695L149.19 20.1613C149.238 18.6954 147.762 17.6349 146.349 18.1183L120.415 27.1168V27.1012Z",
			fill: "url(#paint0_linear_601_27115)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M45.3125 102.426V73.466V50.6189C45.3125 48.8879 43.8841 47.4687 42.1065 47.4687H4.20599C2.44428 47.4687 1 48.8723 1 50.6189V73.466H1.06348C2.4919 105.748 29.5682 131.48 62.7709 131.48H66.7863C68.2941 131.48 69.8177 131.418 71.3255 131.309L74.8806 131.028C58.3269 131.855 45.3125 118.474 45.3125 102.426Z",
			fill: "url(#paint1_linear_601_27115)"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_601_27115",
			x1: 69.5004,
			y1: 120.096,
			x2: 129.39,
			y2: 40.9945,
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("stop", { stopColor: "#C9CAFF" }),
				/* @__PURE__ */ _jsx("stop", {
					offset: .19,
					stopColor: "#C9CAFF"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .7,
					stopColor: "#214EEB"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#132E94"
				})
			]
		}), /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint1_linear_601_27115",
			x1: 37.9483,
			y1: 38.9069,
			x2: 37.9483,
			y2: 130.716,
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("stop", { stopColor: "#C9CAFF" }),
				/* @__PURE__ */ _jsx("stop", {
					offset: .19,
					stopColor: "#C9CAFF"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .7,
					stopColor: "#214EEB"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#132E94"
				})
			]
		})] })
	]
});
export default SvgLogoImage;
